import axiosInstance from './axiosInstance';
import qs from 'qs';

interface TagItem {
  id: number;
  reviewId: number;
  tag: string;
  createdAt: string;
  updatedAt: string;
}

export interface Issue {
  adjusterId: number;
  createdAt: string;
  isPayoutApproved: boolean;
  issueContent: string;
  issueTitle: string;
  tags: string[];
  totalFee?: string | number;
  adjuster: {
    name: string;
    tags: string[];
    profileImage?: string;
  } | null; // adjuster가 null일 수 있으니 처리
}

export interface ReviewDetail {
  id: number;
  title: string;
  content: string;
  createdAt: string;
  incidentDate: string | null | Date;
  viewCount: number;
  tags: TagItem[];
  author: {
    nickname: string;
    insuranceCompanies: string[];
  };
  issues: Issue[]; // ✅ 수정된 부분
}

export interface ReviewTag {
  id: number;
  reviewId: number;
  tag: string;
  createdAt: string;
  updatedAt: string;
}

export interface AdjusterLocation {
  province: string;
  city: string;
  latitude: number;
  longitude: number;
}

export interface Adjuster {
  id: number;
  profileImage: string;
  hasCompletedTraining: boolean;
  name: string;
  phone: string;
  email: string;
  isActive: boolean;
  nickname: string;
  kakaoId: number;
  primaryLocations: AdjusterLocation[];
  deletedAt: string;
  tag: string;
  description: string;
  career: string;
  license: string;
}

export interface ReviewIssue {
  adjusterId: number;
  adjuster: Adjuster;
  issueTitle: string;
  issueContent: string;
  isPayoutApproved: boolean;
  tags: string[];
  createdAt: string;
  totalFee: string;
}

export interface ReviewListItem {
  id: number;
  consultId: number;
  adjusterId: number;
  title: string;
  content: string;
  issues: ReviewIssue[];
  tags: ReviewTag[];
  viewCount: number;
  totalFee: string;
  incidentDate: string | null | Date;
}

export interface ReviewListResponse {
  totalPages: number;
  totalElements: number;
  size: number;
  content: ReviewListItem[];
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
}

export interface FetchReviewListParams {
  page?: number;
  size?: number;
  sort?: string[]; // 예: ['createdAt,desc']
  tags?: string[]; // ✅ array[string]
  keyword?: string; // ✅ keyword
}

// 단건 조회 API
export const fetchReviewDetail = async (id: number): Promise<ReviewDetail> => {
  const response = await axiosInstance.get<ReviewDetail>(`/api/allbadeum/v1/review/${id}`);
  return response.data;
};

// 리뷰 전체 조회

// ✅ 리뷰 전체 조회 API

export const fetchReviewList = async (
  params: FetchReviewListParams,
): Promise<ReviewListResponse> => {
  const { page = 0, size = 10, sort, tags, keyword } = params;

  const queryParams = {
    page,
    size,
    ...(sort?.length ? { sort } : {}),
    ...(tags?.length ? { tags } : {}),
    ...(keyword ? { keyword } : {}),
  };

  const response = await axiosInstance.get<ReviewListResponse>('/api/allbadeum/v1/review', {
    params: queryParams,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }), // ✅ 개별 적용
  });

  return response.data;
};
